import React from 'react';

import { ViewPayoutRecordsFormProps } from '../../../models/kycDetails.model';
import DownloadPayoutDetails from '../basicDetails/DownloadPayoutDetails';

const ViewPayoutRecords: React.FC<ViewPayoutRecordsFormProps> = ({ onCancel, onSubmit, loading }) => {
	return <DownloadPayoutDetails onCancel={onCancel} onSubmit={onSubmit} loading={loading} submitLabel='View' />;
};

export default ViewPayoutRecords;
